// extracted by mini-css-extract-plugin
export default {"hiddenVideoPlayer":"tIvX1W"};